import { Grid } from "@mui/material";

import { EntityInput } from "@dzambalaorg/mui-inputs-entity";
import { ILotteryTicketTokenSearchDto } from "@framework/types";
import { SearchWithFilters } from "@dzambalaorg/mui-form-search";

interface ILotteryTokenSearchFormProps {
  initialValues?: Partial<ILotteryTicketTokenSearchDto>;
}

export const LotteryTokenSearchForm = (props: ILotteryTokenSearchFormProps) => {
  const { initialValues } = props;

  const { roundIds } = initialValues || {};
  const fixedValues: Partial<ILotteryTicketTokenSearchDto> = { roundIds };

  return (
    <SearchWithFilters initialValues={fixedValues}>
      <Grid container spacing={2} alignItems="flex-end">
        <Grid size={{ xs: 12 }}>
          <EntityInput multiple name="roundIds" controller="lottery/rounds" />
        </Grid>
      </Grid>
    </SearchWithFilters>
  );
};
